(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5554,5764],{

/***/ 55133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getFindAStoresResult; },
/* harmony export */   "T": function() { return /* binding */ getAutoSuggestionsInputBased; }
/* harmony export */ });
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73350);

const getFindAStoresResult = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", address = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", brand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", disMiles = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100, maxStorePerPage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 10, locationType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", page = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1, sku = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    const params = {
        address,
        brand: brand.toLowerCase(),
        disMiles,
        maxItemPerPage: maxStorePerPage,
        locationType: locationType.toLowerCase(),
        page
    };
    if (sku) params["sku"] = sku;
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__.apim.get(url, {
        params
    });
};
const getAutoSuggestionsInputBased = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", input = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return _constants_api__WEBPACK_IMPORTED_MODULE_0__.apim.get(url, {
        params: {
            $format: "json",
            brand: brand.toLowerCase(),
            $select: "Locality",
            $filter: "StartsWith(Locality,'".concat(input, "') eq true")
        }
    });
};


/***/ }),

/***/ 59187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ GLOBAL_HEADER_TEXT; },
/* harmony export */   "Pv": function() { return /* binding */ GLOBAL_NAVIGATION; },
/* harmony export */   "WC": function() { return /* binding */ MEGA_MENU; },
/* harmony export */   "zl": function() { return /* binding */ MAIN_MENU; }
/* harmony export */ });
const GLOBAL_HEADER_TEXT = "global header";
const MAIN_MENU = "main dropdown menu";
const MEGA_MENU = "mega menu navigation";
const GLOBAL_NAVIGATION = "global navigation";


/***/ }),

/***/ 24897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jm": function() { return /* binding */ onclickForSignedFun; },
/* harmony export */   "Lz": function() { return /* binding */ newdataLayerForCreateAccount; },
/* harmony export */   "Ps": function() { return /* binding */ backClickForMobile; },
/* harmony export */   "UY": function() { return /* binding */ newdatalayerforSignIn; },
/* harmony export */   "bL": function() { return /* binding */ l1DatalayerclickMobile; },
/* harmony export */   "hJ": function() { return /* binding */ addAnalyticsOnClose; },
/* harmony export */   "ue": function() { return /* binding */ dataLayerForUtilityClicks; },
/* harmony export */   "w_": function() { return /* binding */ hamburgerMenuDatalayer; },
/* harmony export */   "yp": function() { return /* binding */ servicesAnalyticsClick; },
/* harmony export */   "zw": function() { return /* binding */ closeButtonDatalayer; }
/* harmony export */ });
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49139);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);
/* harmony import */ var _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59187);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96301);




const addAnalyticsOnClose = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "main dropdown menu:products:close",
        eventMsg: "n/a",
        eventName: "main dropdown menu:products:close",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "products > close",
        internalLinkPosition: "global header:products",
        internalLinkType: "global header:navigation",
        internalLinkURL: "".concat(window.origin).concat(location.pathname),
        internalLinkZoneName: "main dropdown menu:products"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const servicesAnalyticsClick = (data)=>{
    var ref;
    const { text ="" , link ="" , Leveltwo ="" , L1 ="" , imgcheck =""  } = data;
    const textcont = text ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.makingTextDatalayerReady)(text) : "";
    const l2DatalayerReady = Leveltwo ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.makingTextDatalayerReady)(Leveltwo) : "";
    const l1DatalayerReady = L1 ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.makingTextDatalayerReady)(L1) : "";
    const url = link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.removeAndCleanLink)(link)) : "n/a";
    let internallink;
    if (L1) {
        internallink = "".concat(l1DatalayerReady, " > ").concat(l2DatalayerReady, " > ").concat(imgcheck ? "img_".concat(textcont) : textcont);
    } else if (imgcheck) {
        internallink = "".concat(l2DatalayerReady, " > img_").concat(textcont);
    } else {
        internallink = "".concat(l2DatalayerReady, " > ").concat(textcont);
    }
    const eventInfo = {
        clickInternalLinks: (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) || url === null ? "true" : "false",
        eventAction: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl,
        eventName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl,
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkName: (ref = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getPureText)(internallink)) === null || ref === void 0 ? void 0 : ref.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_3__/* .PURE_DATA_FOR_STRING_REGEX */ .YN, ""),
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
        internalLinkURL: url,
        internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
};
const l1DatalayerclickMobile = function() {
    let L1Name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageNameDatalayer = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl,
        eventName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl,
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_NAVIGATION */ .Pv,
        internalLinkName: L1Name === null || L1Name === void 0 ? void 0 : L1Name.toLowerCase(),
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageNameDatalayer, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A)
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
};
const backClickForMobile = function() {
    let L1Name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":back"),
        eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":back"),
        eventType: "navigation",
        internalLinkName: "".concat(L1Name.toLowerCase(), " > back"),
        internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(L1Name.toLowerCase()),
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl, ":").concat(L1Name.toLowerCase())
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
};
const closeButtonDatalayer = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "products";
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.addMavenoidChat)();
    data = data ? data : "products";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl, ":").concat(data.toLowerCase(), ":close"),
        eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl, ":").concat(data.toLowerCase(), ":close"),
        eventType: "navigation",
        internalLinkName: "".concat(data.toLowerCase(), " > close"),
        internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":products"),
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MAIN_MENU */ .zl, ":products")
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
};
const hamburgerMenuDatalayer = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "hamburger menu open",
        eventName: "hamburger menu open",
        eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_NAVIGATION */ .Pv,
        internalLinkName: "hamburger menu open",
        internalLinkPosition: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
        internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":open"),
        internalLinkURL: "n/a",
        internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
};
const newdatalayerforSignIn = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            eventType: "navigation",
            internalLinkName: "sign in start",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in start"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
    } else {
        const eventInfo1 = {
            eventName: "my account:sign in",
            eventAction: "my account:sign in",
            internalLinkName: "sign in interaction",
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":sign in"),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo1, "cmp:click");
    }
};
const newdataLayerForCreateAccount = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            eventType: "navigation",
            internalLinkName: "create account",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":create account"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
    } else {
        const eventInfo1 = {
            eventName: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.MY_ACCOUNT_MODAL, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            eventAction: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.MY_ACCOUNT_MODAL, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            internalLinkName: _constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT,
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "n/a",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_constants_index__WEBPACK_IMPORTED_MODULE_1__.CREATE_ACCOUNT),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo1, "cmp:click");
    }
};
const onclickForSignedFun = function() {
    let themeChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":your kohler account"),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":your kohler account"),
            eventType: "navigation",
            internalLinkName: "your kohler account",
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":my account"),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
    }
};
const dataLayerForUtilityClicks = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", themeChange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var ref;
    const dataLayerTitle = title === null || title === void 0 ? void 0 : title.toLowerCase();
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const pageNameDatalayer = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
    if (themeChange) {
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            eventName: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            eventType: "navigation",
            internalLinkName: "".concat(dataLayerTitle),
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .MEGA_MENU */ .WC),
            internalLinkURL: url ? "".concat(url.indexOf("http") === -1 ? window.location.origin : "").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.removeAndCleanLink)(url)) : "n/a",
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click");
    } else if (dataLayerTitle === "find a store") {
        const eventInfo1 = {
            eventAction: dataLayerTitle,
            eventName: dataLayerTitle,
            eventType: dataLayerTitle,
            internalLinkName: dataLayerTitle,
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":").concat(dataLayerTitle),
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: "".concat(pageNameDatalayer).concat(pageNameDatalayer ? ":" : "").concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo1, "cmp:click");
    } else {
        dataLayerTitle === "favorites";
        const eventInfo2 = {
            eventName: "wishlist icon",
            eventAction: "wishlist icon",
            internalLinkName: "wishlist",
            internalLinkType: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, ":navigation"),
            internalLinkZoneName: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            clickInternalLinks: "true",
            eventType: _components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A,
            internalLinkURL: "".concat(url),
            internalLinkPosition: "".concat(_components_Shared_HeaderNavTabs_analytics_constant__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_HEADER_TEXT */ .A, " wishlist"),
            eventMsg: "n/a",
            eventStatus: "n/a"
        };
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo2, "cmp:click");
    }
};


/***/ }),

/***/ 67101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_MiniCart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
;// CONCATENATED MODULE: ./public/icons/cart-icon.svg
/* harmony default export */ var cart_icon = ({"src":"/_next/static/media/cart-icon.9accb288.svg","height":25,"width":25});
;// CONCATENATED MODULE: ./public/icons/cart-icon-empty.svg
/* harmony default export */ var cart_icon_empty = ({"src":"/_next/static/media/cart-icon-empty.02db72e9.svg","height":20,"width":26});
;// CONCATENATED MODULE: ./public/icons/cart-gray.svg
/* harmony default export */ var cart_gray = ({"src":"/_next/static/media/cart-gray.abab88ab.svg","height":20,"width":25});
;// CONCATENATED MODULE: ./public/icons/cart-filled.svg
/* harmony default export */ var cart_filled = ({"src":"/_next/static/media/cart-filled.4aa11106.svg","height":20,"width":25});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(30394);
;// CONCATENATED MODULE: ./components/Shared/MiniCart/v1/MiniCart.jsx











const MiniCart = (param)=>{
    let { eventHandler: { store: { cartCount , ariaLabel  } , callbacks: { onClick  }  } , checkoutPage  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const getWidth = window.outerWidth === 0 ? window.innerWidth : lib/* isSafari */.G6 ? window.innerWidth : window.outerWidth;
    const [isMobile, setIsMobile] = (0,react.useState)((getWidth || width) <= 1200);
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const cartGrayFilledIconV3 = "/icons/cart-empty.svg";
    (0,react.useEffect)(()=>{
        !checkoutPage ? setIsMobile((getWidth && width) <= 1200) : setIsMobile(false);
    }, [
        getWidth,
        width,
        checkoutPage
    ]);
    (0,react.useEffect)(()=>{
        (0,cart/* getCartLandingPagePath */.dZ)().then((res)=>{
            setCartUrl(res);
        });
    }, []);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-indicator ".concat(cartCount > 0 && "cart-indicator__with-count"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: cartUrl,
            "aria-label": ariaLabel,
            role: "link",
            className: "gbh-data-layer",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat(cartUrl, '","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"global header:navigation","eventType":"global header","eventAction":"cart icon"}'),
            children: cartCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-indicator__count ".concat(cartCount < 100 && "cart-indicator__count--center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: isMobile ? cart_filled === null || cart_filled === void 0 ? void 0 : cart_filled.src : cart_icon === null || cart_icon === void 0 ? void 0 : cart_icon.src,
                        alt: "Cart"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartCount
                    })
                ]
            }) : themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isMobile ? cartGrayFilledIconV3 : cart_icon_empty.src,
                alt: "Cart"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isMobile ? cart_gray === null || cart_gray === void 0 ? void 0 : cart_gray.src : cart_icon_empty.src,
                alt: "Cart"
            })
        })
    });
};
const checkForRerender = (prevProps, nextProps)=>{
    return nextProps.eventHandler.store.cartCount === prevProps.eventHandler.store.cartCount;
};
/* harmony default export */ var v1_MiniCart = (/*#__PURE__*/(0,react.memo)(MiniCart, checkForRerender));


/***/ }),

/***/ 95518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Shared_UtilityNavHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./store/features/locationSlice.js
var locationSlice = __webpack_require__(56608);
// EXTERNAL MODULE: ./components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(65764);
// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
;// CONCATENATED MODULE: ./public/icons/left-arrow-white.svg
/* harmony default export */ var left_arrow_white = ({"src":"/_next/static/media/left-arrow-white.9ff895f4.svg","height":17,"width":10});
// EXTERNAL MODULE: ./components/FindStoreUtilNav/v1/index.module.scss
var index_module = __webpack_require__(4201);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/core/Modal/ZipCodeInfoModal.jsx
var ZipCodeInfoModal = __webpack_require__(96352);
// EXTERNAL MODULE: ./components/core/AutoSuggestion/v1/AutoSuggestion.jsx
var AutoSuggestion = __webpack_require__(36130);
;// CONCATENATED MODULE: ./components/FindStoreUtilNav/analytics.js

const addFindStoreAnalytics = (zipCodeValue, zipCodeError)=>{
    const { show , message  } = zipCodeError;
    const eventMsg = show ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a";
    const eventStatus = show ? "failure" : "success";
    const eventInfo = {
        eventAction: "find a store:utility nav:submit",
        eventName: "find a store:utility nav:submit",
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName: "submit",
        internalLinkPosition: "find a store",
        internalLinkType: "find a store:".concat(zipCodeValue !== null && zipCodeValue !== void 0 ? zipCodeValue : ""),
        internalLinkZoneName: "find a store:utility nav",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const headerFindStoreUseLocationAnalytics = (param)=>{
    let { errorMessage ="" , staticTexts ={} , eventStatus =""  } = param;
    const eventMsg = errorMessage ? (0,helper.sanitizeTextForAnalytics)(errorMessage ? errorMessage : staticTexts.locationErrormessage) : "n/a";
    const eventInfo = {
        eventAction: "find a store:utility nav:use my location",
        eventName: "find a store:utility nav:use my location",
        eventType: "navigation",
        eventMsg,
        eventStatus,
        internalLinkName: "use my location",
        internalLinkPosition: "global header:find a store",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const headerViewAllStoreAnalytics = (browseAllStoreUrl)=>{
    const eventInfo = {
        eventAction: "find a store:utility nav:view all stores",
        eventName: "find a store:utility nav:view all stores",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view all stores",
        internalLinkPosition: "global header:find a store",
        internalLinkType: "find a store:navigation",
        internalLinkZoneName: "find a store:utility nav",
        internalLinkURL: "".concat(window.location.origin).concat(browseAllStoreUrl),
        clickInternalLinks: "true"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};


// EXTERNAL MODULE: ./components/FindStore/v1/api.js
var api = __webpack_require__(55133);
;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/FindStoreUtilNav.view.jsx






















const configInitialState = {
    browseAllStoreUrl: "",
    brand: "",
    findStores: ""
};
const FindStoreUtilNavView = (props)=>{
    var ref;
    const { findAStoreActive  } = (0,es/* useSelector */.v9)(locationSlice.locationState);
    const [zipCodeValue, setZipcodeValue] = (0,react.useState)("");
    const [isSubmit, setIsSubmit] = (0,react.useState)(false);
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [configState, setConfigState] = (0,react.useState)(configInitialState);
    const [browseAllStoreUrl, setbrowseAllStoreUrl] = (0,react.useState)("");
    const [myStoreUrl, setMyStoreUrl] = (0,react.useState)("/");
    const [optionList, setOptionList] = (0,react.useState)([]);
    const { utilityStoreDetails , utilityData , myStoreId , eventHandler: { callbacks: { toggleFindAStore =()=>{} , closeMenu =()=>{}  }  }  } = props;
    const [infoModalErrror, setInfoModalErrror] = (0,react.useState)({});
    const [infoModal, setInfoModal] = (0,react.useState)();
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const { general  } = config;
            var _allStoresPagePath;
            const url = await (0,utils_location/* getShortenedUrl */.Pp)((_allStoresPagePath = general.allStoresPagePath) !== null && _allStoresPagePath !== void 0 ? _allStoresPagePath : "/");
            const findStores = get_default()(config, "apiEndpoints.findStores", "");
            const brand = get_default()(config, "general.siteName", "");
            setConfigState({
                browseAllStoreUrl: url,
                findStores,
                brand
            });
            localStorage.getItem("currentZipCode") && setZipcodeValue(localStorage.getItem("currentZipCode"));
            setbrowseAllStoreUrl(url);
        }).catch((err)=>console.log(err));
        props.getUtilityGeolocation();
    }, []);
    (0,react.useEffect)(()=>{
        (props === null || props === void 0 ? void 0 : props.active) ? (0,helper.removeMavenoidChat)() : (0,helper.addMavenoidChat)();
    }, [
        props === null || props === void 0 ? void 0 : props.active
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
        if (isSubmit === true) {
            props.redirect(zipCodeValue);
        }
    }, [
        isSubmit
    ]);
    (0,react.useEffect)(()=>{
        if (zipCodeValue.length > 2) {
            fetchListOfCities();
        }
    }, [
        zipCodeValue
    ]);
    (0,react.useEffect)(()=>{
        if (myStoreId === 0) {
            nearestStoreAddress();
        } else {
            dispatch((0,locationSlice.setStoreAddress)(utilityData));
        }
    }, [
        zipCodeValue,
        myStoreId
    ]);
    const nearestStoreAddress = async ()=>{
        const { findStores , brand  } = configState;
        const nearestStore = await (0,api/* getFindAStoresResult */.R)(findStores, zipCodeValue, brand, 100, 1, "kohler store", 1);
        if (nearestStore !== undefined) {
            var ref;
            var ref1;
            const nearestStoreData = (ref1 = nearestStore === null || nearestStore === void 0 ? void 0 : (ref = nearestStore.data) === null || ref === void 0 ? void 0 : ref.info[0]) !== null && ref1 !== void 0 ? ref1 : {};
            var ref2;
            const utilityData = {
                ...nearestStoreData,
                EntityID: (ref2 = nearestStoreData === null || nearestStoreData === void 0 ? void 0 : nearestStoreData.BPnumber) !== null && ref2 !== void 0 ? ref2 : null
            };
            dispatch((0,locationSlice.setStoreAddress)(utilityData));
        } else {
            const utilityData1 = {};
            dispatch((0,locationSlice.setStoreAddress)(utilityData1));
        }
    };
    const fetchListOfCities = async ()=>{
        const { findStores , brand  } = configState;
        const responseData = await (0,helper.getCityList)(findStores, brand, zipCodeValue);
        const { data: { d: { results =[]  } = {}  } = {}  } = responseData;
        const cities = results.map((city)=>city.Locality);
        setOptionList([
            ...new Set(cities)
        ]);
    };
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(utilityStoreDetails) && (utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber)) {
            (0,utils_location/* getShortenedUrl */.Pp)(utilityStoreDetails[utilityData.BPnumber]).then((myStoreUrl)=>{
                setMyStoreUrl(myStoreUrl);
            });
        }
    }, [
        utilityStoreDetails,
        utilityData
    ]);
    const handleChange = (value)=>{
        setZipcodeValue(value);
    };
    const getGeoLocation = ()=>{
        (0,helper.getMyLocation)().then((getLocation)=>{
            var _zipcode;
            setZipcodeValue((_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "");
            headerFindStoreUseLocationAnalytics({
                eventStatus: "success"
            });
        }).catch((param)=>{
            let { cause  } = param;
            setInfoModalErrror(cause !== null && cause !== void 0 ? cause : {});
            setInfoModal(true);
            var ref;
            headerFindStoreUseLocationAnalytics({
                errorMessage: (ref = cause === null || cause === void 0 ? void 0 : cause.message) !== null && ref !== void 0 ? ref : "",
                staticTexts,
                eventStatus: "failure"
            });
        });
    };
    const onSubmit = async ()=>{
        let valid = true;
        const zipCodeErrObj = {
            show: false,
            message: ""
        };
        const { staticTexts: { validZipcode  }  } = props;
        const isValid = await (0,utils_location/* validateField */.OP)("zipCodeNumeric", zipCodeValue);
        if (isValid && zipCodeValue.length < 5) {
            dispatch((0,locationSlice.setUtilityLocation)({
                utilityLocation: zipCodeValue
            }));
            zipCodeErrObj.show = true;
            zipCodeErrObj.message = validZipcode;
            valid = false;
        }
        if (valid) {
            setIsSubmit(true);
            toggleFindAStore();
            closeMenu();
        }
        if (findAStoreActive) {
            dispatch((0,locationSlice.setFindAStoreActive)(false));
        }
        setZipCodeError({
            ...zipCodeErrObj
        });
        addFindStoreAnalytics(zipCodeValue, zipCodeErrObj);
    };
    const getStoreAnalytics = (action)=>{
        var ref;
        const href = utilityStoreDetails && utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] ? utilityStoreDetails[utilityData === null || utilityData === void 0 ? void 0 : utilityData.BPnumber] : "/";
        const internalLinkName = action === "unset as my store" ? "unset as preferred store" : "store details";
        return JSON.stringify({
            eventAction: "find a store:utility nav​:" + action,
            eventName: "find a store:utility nav​:" + action,
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName,
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:" + ((ref = (utilityData === null || utilityData === void 0 ? void 0 : utilityData.LocationName) + ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine) + (!isEmpty_default()(utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) ? ", " + (utilityData === null || utilityData === void 0 ? void 0 : utilityData.AddressLine2) : "") + ", " + (0,helper.formatPhoneNumber)(utilityData === null || utilityData === void 0 ? void 0 : utilityData.Phone)) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            internalLinkZoneName: "find a store:utility nav",
            internalLinkURL: action === "view store details" ? href.indexOf("http") === -1 ? window.location.origin + href : href : "n/a",
            clickInternalLinks: "true"
        });
    };
    const viewStoreAnalytics = getStoreAnalytics("view store details");
    const unsetMyStoreAnalytics = getStoreAnalytics("unset as my store");
    const { staticTexts  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).findAStoreUtilNavWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-find-a-store ".concat(props.active ? "active" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "findstore-util-nav".concat(isSubmit ? "__activeMap" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipCodeInfoModal/* default */.Z, {
                        handleModalClose: ()=>{
                            setInfoModal(false);
                        },
                        show: infoModal,
                        data: infoModalErrror,
                        labelledBy: "Geo-Location-error-message",
                        className: "message-modal",
                        staticTexts: staticTexts,
                        dataLayerPosition: "global header"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "findstore-util-nav__container findstore-util-nav__show-container",
                            children: [
                                lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "findstore-util-nav__mobile-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "button",
                                            tabIndex: "0",
                                            src: close_white/* default.src */.Z.src,
                                            alt: staticTexts.close,
                                            className: "findstore-util-nav__close",
                                            onClick: ()=>{
                                                (0,helper.addMavenoidChat)();
                                                toggleFindAStore(), closeMenu(), (0,helper.toggeleBodyScroll)(false);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "findstore-util-nav__menu",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: left_arrow_white.src,
                                                    alt: staticTexts.leftArrow
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "button",
                                                    onClick: ()=>toggleFindAStore(),
                                                    children: staticTexts.menu
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "findstore-util-nav__content ".concat(!isEmpty_default()(utilityData) && "findstore-util-nav__content-text"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "container kf-react-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row ml-0 mr-0",
                                            children: [
                                                !isEmpty_default()(utilityData && utilityData.EntityID) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-lg-7 findstore-util-nav__access-utility-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-12 col-lg-7 findstore-util-nav__supply-section",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__store",
                                                                        children: myStoreId !== 0 ? staticTexts.myStoreText : staticTexts.closestStore
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__signStore",
                                                                        children: utilityData.LocationName
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-12 col-lg-5 findstore-util-nav__address-container",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: utilityData.OpenUntil
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.AddressLine
                                                                            }),
                                                                            !isEmpty_default()(utilityData.AddressLine2) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.AddressLine2
                                                                            }) : "",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: utilityData.Locality + ", " + utilityData.AdminDistrict + " " + utilityData.PostalCode
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: (0,helper.formatPhoneNumber)(utilityData.Phone)
                                                                    }),
                                                                    myStoreUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: myStoreUrl,
                                                                        className: "findstore-util-nav__view-store-detail gbh-data-layer",
                                                                        "data-gbh-data-layer": viewStoreAnalytics,
                                                                        onClick: ()=>{
                                                                            lib/* isMobile */.tq ? closeMenu() : "";
                                                                        },
                                                                        children: lib/* isMobile */.tq ? staticTexts.storeDetail : staticTexts.viewStoreDetail
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox["default"], {
                                                                        analyticsData: unsetMyStoreAnalytics,
                                                                        checked: myStoreId === utilityData.EntityID ? true : false,
                                                                        value: myStoreId === utilityData.EntityID ? staticTexts.myStore : staticTexts.setAsMyStore,
                                                                        id: "findstore-util-nav__my-store",
                                                                        onChange: (e)=>props.handleUtilityStoreCheck(e.target.checked ? utilityData.EntityID : 0)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 col-lg-6 findstore-util-nav__search-utility-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__location-content",
                                                            children: (0,helper.sanitizeInnerHtml)(staticTexts.locationDescription)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__zipcode-content",
                                                            children: (0,helper.sanitizeInnerHtml)(staticTexts.zipCodeContent)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 findstore-util-nav__loc-search-container ".concat(!isEmpty_default()(utilityData) ? "col-lg-5" : "col-lg-6"),
                                                    children: [
                                                        !isEmpty_default()(utilityData) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "findstore-util-nav__not-your-store",
                                                            children: staticTexts.NotYourStore + "?"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classnames_default()({
                                                                "findstore-util-nav__input-container": true,
                                                                "findstore-util-nav__input-container-text": !isEmpty_default()(utilityData),
                                                                "findstore-util-nav__input-disabled-state": !zipCodeValue
                                                            }),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion/* default */.Z, {
                                                                    placeholderLabel: staticTexts.enterCityStateZip,
                                                                    selectedValue: zipCodeValue,
                                                                    handleChange: (selectedVal)=>handleChange(selectedVal),
                                                                    handleSelect: (selectedVal)=>handleChange(selectedVal),
                                                                    optionList: optionList,
                                                                    borderValue: "bottom"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "findstore-util-nav__submit",
                                                                    onClick: ()=>onSubmit(),
                                                                    disabled: zipCodeValue.length < 3,
                                                                    "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.submit,
                                                                    children: staticTexts.submit
                                                                })
                                                            ]
                                                        }),
                                                        zipCodeError.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "findstore-util-nav__zipcode-error",
                                                            children: zipCodeError.message
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "findstore-util-nav__link-container ".concat(!isEmpty_default()(utilityData) && "findstore-util-nav__link-container-text"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "findstore-util-nav__location-link-container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "findstore-util-nav__location-link",
                                                                        "aria-label": staticTexts.useLocation,
                                                                        role: "button",
                                                                        tabIndex: "0",
                                                                        onClick: getGeoLocation,
                                                                        children: staticTexts.useLocation
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "findstore-util-nav__view-link-container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: browseAllStoreUrl,
                                                                        className: "findstore-util-nav__view-store-link ".concat(lib/* isMobile */.tq ? "view-all-stores-mobile" : "", " gbh-data-layer"),
                                                                        onClick: ()=>{
                                                                            headerViewAllStoreAnalytics(browseAllStoreUrl);
                                                                        },
                                                                        onClickCapture: ()=>{
                                                                            toggleFindAStore();
                                                                            closeMenu();
                                                                        },
                                                                        children: staticTexts.viewAllStore
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
FindStoreUtilNavView.defaultProps = {
    staticTexts: {}
};
FindStoreUtilNavView.propTypes = {
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var FindStoreUtilNav_view = (FindStoreUtilNavView);

;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/localization.js
const getTranslations = (t)=>{
    return {
        useLocation: t("kf.findStoreUtilNav.label.useLocation"),
        viewAllStore: t("kf.findStoreUtilNav.label.viewAllStore"),
        submit: t("kf.global.label.submit"),
        findStore: t("kf.findStoreUtilNav.label.findStore"),
        closestStore: t("kf.findStoreUtilNav.label.closestStore"),
        kohlerText: t("kf.findStoreUtilNav.label.kohler"),
        signStore: t("kf.findStoreUtilNav.label.signStore"),
        NotYourStore: t("kf.findStoreUtilNav.label.NotYourStore"),
        viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
        storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
        setAsMyStore: t("kf.findStoreUtilNav.label.setAsMystore"),
        myStore: t("kf.findStoreUtilNav.label.myStore"),
        myStoreText: t("kf.findStoreUtilNav.label.myStoreText"),
        locationDescription: t("kf.findStoreUtilNav.label.locationDescription"),
        zipCodeContent: t("kf.findStoreUtilNav.label.zipCodeContent"),
        closeAlt: t("kf.findStoreUtilNav.label.closeAlt"),
        menu: t("kf.findStoreUtilNav.label.menu"),
        leftArrow: t("kf.findStoreUtilNav.label.leftArrow"),
        enterZipCode: t("kf.findStoreUtilNav.label.enterZipCode"),
        zipcode: t("kf.findStoreUtilNav.zipcode"),
        validZipcode: t("kf.findStoreUtilNav.validZipcode"),
        MessageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
        infoModalTitle: t("kf.findStoreUtilNav.messageTitleZipcode"),
        zipcodeEmptyError: t("kf.findStoreUtilNav.zipcodeEmptyError"),
        continue: t("kf.checkout.label.continue"),
        ariaLabel: {
            enterZipCode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
            submit: t("kf.findStoreUtilNav.aria.label.submit")
        },
        enterCityStateZip: t("kf.findStoreUtilNav.label.countryPlaceholder")
    };
};

;// CONCATENATED MODULE: ./components/FindStoreUtilNav/v1/FindStoreUtilNav.jsx













const FindStoreUtilNav = (param)=>{
    let { show , active , eventHandler , zipCodeContent  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { utilityStoreDetails , utilityData , userCity , myStoreId  } = (0,es/* useSelector */.v9)(locationSlice.locationState);
    const initialState = {
        userCity: "",
        utilityLocation: "",
        utilityData: {},
        utilityStoreDetails: {},
        findStores: "",
        reverseGeo: "",
        myStoreId: typeof Window !== "undefined" ? localStorage.getItem("myStoreId") : 0,
        siteName: "",
        findStoreUrl: "",
        utilityStoreDetailsUrl: ""
    };
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const router = (0,next_router.useRouter)();
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)(initialState);
    (0,react.useEffect)(()=>{
        setStaticTexts((prevVal)=>{
            let translations = getTranslations(t);
            if (zipCodeContent && zipCodeContent.length) {
                translations = {
                    ...translations,
                    zipCodeContent
                };
            }
            return translations;
        });
        setInitalState();
    }, []);
    // useEffect(() => {
    //   document.querySelector(
    //     ".gbh-nav__findStore a.gbh-nav__findStore--link"
    //   ).innerText = "staticTexts.findStore"
    // }, [userCity, staticTexts.findStore])
    (0,react.useEffect)(()=>{
        if (state.myStoreId !== 0) getUtilityDataById();
        else if (state.userCity !== "") getUtilityDataByDistance();
    }, [
        state.utilityLocation,
        state.userCity
    ]);
    (0,react.useEffect)(()=>{
        if (state.utilityStoreDetailsUrl !== "") setUtilityStoreDetailsUrl();
    }, [
        state.utilityStoreDetailsUrl
    ]);
    const setInitalState = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        getFindStoreUrl(config).then((url)=>{
            setState({
                ...state,
                findStores: get_default()(config, "apiEndpoints.findStores", ""),
                reverseGeo: get_default()(config, "apiEndpoints.reverseGeo", ""),
                siteName: get_default()(config, "general.siteName", ""),
                utilityStoreDetailsUrl: get_default()(config, "general.storeDetailsServletPath"),
                findStoreUrl: url
            });
        });
    };
    const getFindStoreUrl = async (config)=>{
        const findStoreUrl = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.findStorePagePath", ""));
        return findStoreUrl;
    };
    const setUtilityStoreDetailsUrl = async ()=>{
        const utilityStoreDetails = await (0,utils_location/* getUtilityStoreDetails */.BO)(state);
        dispatch((0,locationSlice.setUtilityStoreDetails)(utilityStoreDetails));
        setState({
            ...state,
            utilityStoreDetails
        });
    };
    const getUtilityDataByDistance = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataByDistance */.zO)(state);
        dispatch((0,locationSlice.setStoreAddress)(utilityData));
        setState({
            ...state,
            utilityData
        });
    };
    const getUtilityDataById = async ()=>{
        const utilityData = await (0,utils_location/* getStoreDataById */.e)(state);
        dispatch((0,locationSlice.setStoreAddress)(utilityData));
        setState({
            ...state,
            utilityData
        });
    };
    const getUtilityGeolocation = function() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0,helper.getMyLocation)().then((getLocation)=>{
            const { zipcode: utilityLocation = "" , city: userCity = ""  } = getLocation;
            const details = {
                utilityLocation,
                userCity
            };
            if (utilityLocation && userCity) {
                dispatch((0,locationSlice.setCityLocation)(details));
                setState({
                    ...state,
                    ...details
                });
            }
        }).catch((err)=>{
            (0,helper.getMyLocationByUserIP)().then((getLocation)=>{
                const { zipcode: utilityLocation = "" , city: userCity = ""  } = getLocation;
                const details = {
                    utilityLocation,
                    userCity
                };
                if (utilityLocation && userCity) {
                    dispatch((0,locationSlice.setCityLocation)(details));
                    setState({
                        ...state,
                        ...details
                    });
                }
            }).catch((error)=>{
                console.log(error);
            });
        });
    };
    const handleUtilityStoreCheck = (entity)=>{
        localStorage.setItem("myStoreId", entity);
        dispatch((0,locationSlice.setMyStore)(entity));
        setState({
            ...state,
            myStoreId: entity
        });
    };
    const redirect = (zipCodeValue)=>{
        const path = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue, "&queryAspath=").concat(state.findStoreUrl);
        const asPath = "".concat(state.findStoreUrl, "?q=").concat(zipCodeValue);
        router.push(path, asPath);
    };
    const { findStoreUrl  } = state;
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindStoreUtilNav_view, {
        staticTexts: staticTexts,
        getUtilityGeolocation: getUtilityGeolocation,
        redirect: (zipCodeValue)=>redirect(zipCodeValue),
        redirectUrl: (0,utils_location/* getShortenedUrl */.Pp)(findStoreUrl),
        handleUtilityStoreCheck: (entity)=>handleUtilityStoreCheck(entity),
        active: active,
        utilityStoreDetails: utilityStoreDetails,
        utilityData: utilityData,
        userCity: userCity,
        myStoreId: myStoreId,
        eventHandler: eventHandler
    });
};
/* harmony default export */ var v1_FindStoreUtilNav = (FindStoreUtilNav);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(30394);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/index.js
var analytics = __webpack_require__(24897);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav.view/index.jsx










const MegaMenu = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7437).then(__webpack_require__.bind(__webpack_require__, 67437)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(67437)
            ]
    },
    suspense: true
});
const AuthUtilityNavView = (props)=>{
    const avatarIcon = "/icons/avatar.svg";
    const rightArrow = "/icons/right-white.svg";
    const iconUserSignin = "/icons/user-signin.svg";
    const { active , i18n , userMenuFragment , guestMenuFragment , isLoggedIn , logout , toggleAuthNav , setAuthNav , onAuthMenuClick  } = props;
    const { user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const styleClass = classnames_default()({
        "auth-nav": true,
        "auth-nav--active": active
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        (0,analytics/* newdatalayerforSignIn */.UY)(themeChange);
    };
    const onClickSignUp = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: 1
        }));
        (0,analytics/* newdataLayerForCreateAccount */.Lz)(themeChange);
    };
    const showMenuNav = ()=>{
        toggleAuthNav();
    };
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    const signInEventInfo = JSON.stringify({
        eventName: "sign in start",
        eventAction: "sign in start",
        internalLinkName: "sign in start",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "global header",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header:sign in start",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    const signedInEventInfo = JSON.stringify({
        eventName: "global header:your kohler account",
        eventAction: "global header:your kohler account",
        internalLinkName: "your kohler account",
        internalLinkType: "global header: welcome back to your kohler",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header:my account",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styleClass,
        "aria-expanded": active,
        children: [
            winWidth <= 1200 ? isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    tabIndex: "0",
                    "aria-label": "".concat(i18n.hi, " ").concat((0,helper.capitalizeFirstName)(user === null || user === void 0 ? void 0 : user.firstName)),
                    role: "button",
                    className: "auth-nav__sign-in-mobile",
                    onClick: ()=>{
                        toggleAuthNav();
                        onAuthMenuClick(!active);
                        setAuthNav(!active);
                        (0,helper.toggeleBodyClass)(true);
                        (0,analytics/* onclickForSignedFun */.Jm)(themeChange);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            name: "avatarIcon",
                            src: themeChange ? iconUserSignin : avatarIcon,
                            alt: i18n.signIn,
                            className: "gbh-data-layer auth-nav__sign-in-avatar",
                            "data-gbh-data-layer": signInEventInfo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            name: "loggedInUser",
                            className: "auth-nav__user",
                            children: [
                                i18n.hi,
                                ", ",
                                (0,helper.capitalizeFirstName)(user === null || user === void 0 ? void 0 : user.firstName)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: rightArrow,
                            alt: i18n.rightArrowAlt,
                            className: "auth-nav__sign-in-right-arrow"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: "Loading...",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                    userMenuFragment: userMenuFragment,
                    guestMenuFragment: guestMenuFragment,
                    isLoggedIn: isLoggedIn,
                    i18n: i18n,
                    user: user,
                    logout: logout,
                    toggleAuthNav: toggleAuthNav,
                    active: active,
                    handleSignin: onClickSignIn,
                    handleCreateAccount: onClickSignUp
                })
            }) : isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                tabIndex: "0",
                role: "button",
                "aria-label": active ? "".concat(i18n.user, " ").concat(i18n.expanded) : "".concat(i18n.user, " ").concat(i18n.collapsed),
                name: "loggedInUser",
                className: "auth-nav__user gbh-data-layer",
                onClick: showMenuNav,
                "data-gbh-data-layer": signedInEventInfo,
                children: [
                    i18n.hi,
                    ", ",
                    (0,helper.capitalizeFirstName)(user === null || user === void 0 ? void 0 : user.firstName)
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                tabIndex: "0",
                role: "button",
                name: "avatarIcon",
                "aria-label": active ? "".concat(i18n.signIn, " ").concat(i18n.expanded) : "".concat(i18n.signIn, " ").concat(i18n.collapsed),
                src: avatarIcon,
                alt: i18n.signIn,
                onClick: showMenuNav,
                className: "gbh-data-layer",
                "data-gbh-data-layer": signInEventInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "auth-nav__menu ".concat(isLoggedIn ? "auth-nav__menu-expand" : "", " ").concat(active ? "auth-nav__menu-open" : ""),
                "aria-hidden": !active,
                children: active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "Loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                        userMenuFragment: userMenuFragment,
                        guestMenuFragment: guestMenuFragment,
                        isLoggedIn: isLoggedIn,
                        i18n: i18n,
                        user: user,
                        logout: logout,
                        toggleAuthNav: toggleAuthNav,
                        handleSignin: onClickSignIn,
                        handleCreateAccount: onClickSignUp,
                        onAuthMenuClick: onAuthMenuClick
                    })
                }) : null
            })
        ]
    });
};
AuthUtilityNavView.displayName = "AuthUtilityNavView";
/* harmony default export */ var AuthUtilityNav_view = (AuthUtilityNavView);

;// CONCATENATED MODULE: ./i18n/useAuthUtilityNavi18n.js

const useAuthUtilityNavi18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        favorites: t("Favorites"),
        signIn: t("Sign In"),
        createAccount: t("Create Account"),
        hi: t("kf.auth.label.hi"),
        title: t("kf.auth.label.bannerMssg"),
        welcome: t("kf.auth.label.welcome"),
        logout: t("kf.auth.label.logout"),
        rightArrowAlt: t("kf.auth.label.rightArrowAlt"),
        leftArrowAlt: t("kf.auth.label.rightArrowAlt"),
        menu: t("kf.auth.label.menu"),
        expanded: t("kf.auth.label.expanded"),
        collapsed: t("kf.auth.label.collapsed"),
        user: t("kf.auth.label.user"),
        storeOperations: t("kf.account.label.storeOperations")
    };
    return i18n;
};
/* harmony default export */ var i18n_useAuthUtilityNavi18n = (useAuthUtilityNavi18n);

// EXTERNAL MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.module.scss
var AuthUtilityNav_index_module = __webpack_require__(50238);
var AuthUtilityNav_index_module_default = /*#__PURE__*/__webpack_require__.n(AuthUtilityNav_index_module);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.jsx










// import useOnClickOutside from "@/hooks/useOnClickOutside"

const AuthUtilityNav = (props)=>{
    const { show , active , toggleAuthNav , setAuthNav , onAuthMenuClick  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const authNavMenuRef = (0,react.useRef)(null);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { guestMenuFragment , userMenuFragment  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    // useOnClickOutside(authNavMenuRef, toggleAuthNav)
    (0,react.useEffect)(()=>{
        if (show || lib/* isMobile */.tq) {
            (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
                const userFragment = get_default()(CONFIG, "general.signInFragment", "");
                const guestFragment = get_default()(CONFIG, "general.signUpFragment", "");
                const guestMenuPayload = {
                    reload: false,
                    path: guestFragment,
                    fragmentName: "guestMenuFragment"
                };
                dispatch((0,genericSlice.getAuthMenuFragment)(guestMenuPayload));
                const userMenuPayload = {
                    reload: false,
                    path: userFragment,
                    fragmentName: "userMenuFragment"
                };
                dispatch((0,genericSlice.getAuthMenuFragment)(userMenuPayload));
            });
        }
    }, [
        show
    ]);
    const staticTexts = i18n_useAuthUtilityNavi18n();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "listitem",
        className: "auth-widget auth-widget__menu position_unset ".concat((AuthUtilityNav_index_module_default()).authUtilityNavWrapper),
        ref: authNavMenuRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthUtilityNav_view, {
            show: show,
            active: active,
            toggleAuthNav: toggleAuthNav,
            i18n: staticTexts,
            userMenuFragment: userMenuFragment,
            guestMenuFragment: guestMenuFragment,
            isLoggedIn: isAuth,
            logout: ()=>dispatch((0,authSlice/* logout */.kS)()),
            setAuthNav: setAuthNav,
            onAuthMenuClick: onAuthMenuClick
        })
    });
};
/* harmony default export */ var v1_AuthUtilityNav = (AuthUtilityNav);

// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavLink.jsx


const CountryUtilNavLink = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , isMobile , datalayerPageName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: languageLink,
        "aria-label": "".concat(countryName, " ").concat(language),
        className: "gbh-data-layer lang ".concat(isMobile && "mobile"),
        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"languageselector","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat(languageLink, '","internalLinkName":"language select:').concat(isMobile ? language.toLowerCase() : languageAbbreviation.toLowerCase(), '","eventName":"language selector","internalLinkType":"homepage:navigation","eventType":"language selector","eventAction":"language selector"}'),
        rel: "noreferrer",
        children: isMobile ? language : languageAbbreviation
    });
};
/* harmony default export */ var v1_CountryUtilNavLink = (CountryUtilNavLink);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavLinks.jsx



const CountryUtilNavLinks = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , datalayerPageName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: false,
                    datalayerPageName: datalayerPageName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: true,
                    datalayerPageName: datalayerPageName
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNavLinks = (CountryUtilNavLinks);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilContainer.jsx





const CountryUtilContainer = (props)=>{
    const { countryarea , activeTab , title , description , countryselectorItems , datalayerPageName  } = props;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const [expanded, setExpanded] = (0,react.useState)([]);
    const handleExpand = (url, country)=>{
        if (!url) {
            if (expanded.includes(country)) {
                const exp = [
                    ...expanded
                ].filter((item)=>item !== country);
                setExpanded(exp);
            } else {
                const exp1 = [
                    ...expanded
                ];
                exp1.push(country);
                setExpanded(exp1);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: countryarea,
        className: "gbh-tab__content ".concat(activeTab === countryarea ? "gbh-tab__content--active" : "", " "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-lg-4 left d-none d-lg-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(description)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-lg-8 right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 col-12 p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "gbh-tab__list",
                                    role: "list",
                                    children: countryselectorItems && countryselectorItems.map(function(item, index) {
                                        var ref;
                                        if (!item.country) return null;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            role: "listitem",
                                            className: "".concat(item.country).concat(winWidth <= 1200 && !item.countryLink ? " arrowdropdown" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: (ref = item.countryLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                    className: "gbh-data-layer gbh-tab__item--link",
                                                    role: "link",
                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"n/a","internalLinkName":"country select:').concat(item.countryName.toLowerCase(), '","eventName":"country selector","internalLinkType":"homepage:navigation","eventType":"country selector","eventAction":"country selector"}'),
                                                    "aria-current": "page",
                                                    onClick: ()=>handleExpand(item.countryLink, item.country),
                                                    children: [
                                                        item.countryName,
                                                        " "
                                                    ]
                                                }),
                                                (item.languageOneAbbreviation || item.languageTwoAbbreviation || item.languageThreeAbbreviation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    style: expanded.includes(item.country) ? {
                                                        display: "block"
                                                    } : {},
                                                    children: [
                                                        item.languageOneAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageOneLink,
                                                            language: item.languageOne,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageOneAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageTwoAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageTwoLink,
                                                            language: item.languageTwo,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageTwoAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageThreeAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageThreeLink,
                                                            language: item.languageThree,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageThreeAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "".concat(item.country, "+").concat(index));
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_CountryUtilContainer = (CountryUtilContainer);

;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNavTabLink.jsx


const CountryUtilNavTabLink = (props)=>{
    const { activeTab , countryArea , onclickVal , countryAreaValue  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        onClick: ()=>{
            onclickVal(countryArea);
        },
        "data-tab": countryArea,
        role: "tab",
        tabIndex: "0",
        "data-region": "#".concat(countryArea),
        "aria-label": countryArea,
        className: "gbh-tabs__tab ".concat(activeTab === countryArea ? "gbh-tabs__tab--active" : ""),
        "data-testid": "countrySelectorSection_tabLink",
        children: countryAreaValue
    });
};
/* harmony default export */ var v1_CountryUtilNavTabLink = (CountryUtilNavTabLink);

// EXTERNAL MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNav.module.scss
var CountryUtilNav_module = __webpack_require__(19371);
var CountryUtilNav_module_default = /*#__PURE__*/__webpack_require__.n(CountryUtilNav_module);
;// CONCATENATED MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNav.jsx






const CountryUtilNav = (props)=>{
    const { show , active , toggleCountryNav , eventHandler , countryselector , datalayerPageName , v3  } = props;
    const { callbacks: { setRegionNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const [activeTab, setActiveTab] = (0,react.useState)("");
    const addCountrySelectorAnalytics = (type)=>{
        let eventInfo;
        if (type === "Americas") {
            eventInfo = getAmericaTabEventInfo(type);
        } else if (type === "Africa") {
            eventInfo = getAfricaTabEventInfo(type);
        } else if (type === "Asia") {
            eventInfo = getAsiaTabEventInfo(type);
        } else if (type === "Australasia") {
            eventInfo = getAustralasiaTabEventInfo(type);
        } else if (type === "Middle East") {
            eventInfo = getMiddleEastTabEventInfo(type);
        } else if (type === "Europe") {
            eventInfo = getEuropeTabEventInfo(type);
        }
        const page = window.pageObj || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const getAmericaTabEventInfo = (type)=>{
        if (type === "Americas") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:americas",
                eventName: "country select:americas",
                eventType: "navigation",
                internalLinkName: "americas",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAfricaTabEventInfo = (type)=>{
        if (type === "Africa") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:africa",
                eventName: "country select:africa",
                eventType: "navigation",
                internalLinkName: "africa",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAsiaTabEventInfo = (type)=>{
        if (type === "Asia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:asia",
                eventName: "country select:asia",
                eventType: "navigation",
                internalLinkName: "asia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAustralasiaTabEventInfo = (type)=>{
        if (type === "Australasia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:australasia",
                eventName: "country select:australasia",
                eventType: "navigation",
                internalLinkName: "australasia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getMiddleEastTabEventInfo = (type)=>{
        if (type === "Middle East") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:middle east",
                eventName: "country select:middle east",
                eventType: "navigation",
                internalLinkName: "middle east",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getEuropeTabEventInfo = (type)=>{
        if (type === "Europe") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:europe",
                eventName: "country select:europe",
                eventType: "navigation",
                internalLinkName: "europe",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    (0,react.useEffect)(()=>{
        if (winWidth <= 1200) {
            setActiveTab("");
        } else {
            setActiveTab("america");
        }
    }, [
        winWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CountryUtilNav_module_default()).countrySelectorMain,
        "data-testid": "countrySelectorSection",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "gbh_utheader",
            className: "gbh-countryselector ".concat(active ? "active" : ""),
            style: show ? {
                left: 0,
                display: "block"
            } : {
                display: "block"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gbh-tab",
                    children: [
                        !v3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            "data-testid": "countrySelectorSection_menu",
                            className: "gbh-close-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>{
                                toggleCountryNav(), setRegionNav(false);
                            },
                            children: "Menu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            role: "tablist",
                            "aria-multiselectable": "false",
                            className: "tablist",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "selection-bar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Americas"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "america",
                                        countryAreaValue: "Americas",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Africa"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "africa",
                                        countryAreaValue: "Africa",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Asia"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "asia",
                                        countryAreaValue: "Asia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Australasia"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "australia",
                                        countryAreaValue: "Australasia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Middle East"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "middleEast",
                                        countryAreaValue: "Middle East",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Europe"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "europe",
                                        countryAreaValue: "Europe",
                                        onclickVal: setActiveTab
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gbh-tab__panels",
                    style: winWidth <= 1200 && activeTab ? {
                        display: "block"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            className: "gbh-back-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>setActiveTab(""),
                            children: "Region"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "america",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.americasItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "africa",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.africaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "asia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.asiaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "australia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.oceaniaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "middleEast",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.middleEastItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "europe",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.europeItems,
                            datalayerPageName: datalayerPageName
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNav = (CountryUtilNav);

// EXTERNAL MODULE: ./components/Shared/MiniCart/v1/MiniCart.jsx + 4 modules
var MiniCart = __webpack_require__(67101);
// EXTERNAL MODULE: ./components/Shared/index.module.scss
var Shared_index_module = __webpack_require__(3738);
var Shared_index_module_default = /*#__PURE__*/__webpack_require__.n(Shared_index_module);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./constants/api.js
var constants_api = __webpack_require__(73350);
// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss
var UtilityWidgets_module = __webpack_require__(84181);
var UtilityWidgets_module_default = /*#__PURE__*/__webpack_require__.n(UtilityWidgets_module);
;// CONCATENATED MODULE: ./components/Shared/helper.js
const getSrc = (themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)=>{
    if (!themeChange) {
        return favoritesPage && favoritesPage.length > 0 ? "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTUgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbi9XaXNobGlzdDwvdGl0bGU+CiAgICA8ZyBpZD0iQjEtQ29tcGFyZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb24vV2lzaGxpc3QiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAtOC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPHBhdGggZD0iTTguMTQwNjA3MTQsOS42ODg0ODE5NyBMNy41MDEsMTAuMzM0IEw2Ljg2MTU5MzY5LDkuNjg4NDgxOTcgQzUuMjkyNDIzNTIsOC4xMDM4MzkzNCAyLjc0NjI0NDc5LDguMTAzODM5MzQgMS4xNzcwNzQ2Myw5LjY4ODQ4MTk3IEMtMC4zNDg3ODE5NTgsMTEuMjI5MzgzOSAtMC4zOTYyNTE5NTksMTMuNzE4NTgzNCAxLjA2NDMyMjM2LDE1LjI5NzA0NDIgTDEuMTcwNzE4NTIsMTUuNDA4NTcwNyBMNy41MDExMTM0NCwyMS44MDE1MDMzIEwxMy44MDg0ODM5LDE1LjQzMjE5OTggTDEzLjkxNTE4NzgsMTUuMzIxMTQwOCBDMTUuMzk1NTk2OCwxMy43MjE3MTI1IDE1LjM1Mzk3MDMsMTEuMjMyNDAxIDEzLjgyNTEyNjIsOS42ODg0ODE5NyBDMTIuMjU1OTU2LDguMTAzODM5MzQgOS43MDk3NzczMSw4LjEwMzgzOTM0IDguMTQwNjA3MTQsOS42ODg0ODE5NyBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+" : "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4=";
    } else {
        return favoritesPage && favoritesPage.length > 0 ? iconFavoriteBlack : iconFavorite;
    }
};

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/Shared/UtilityNavHeader.jsx

























const UtilityNavHeader = (param)=>{
    let { data , eventHandler , toggleMenu =()=>{}  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    const [favoritesPagePath, setFavoritesPagePath] = (0,react.useState)("/");
    const { ":items": { store: { zipCodeContent =""  } = {}  } = {}  } = data;
    const { findAStoreShow , findAStoreActive  } = (0,es/* useSelector */.v9)(locationSlice.locationState);
    const { store: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  } , callbacks: { // eslint-disable-next-line no-console
    setRegionNav =()=>console.log("Event Not Defined") , // eslint-disable-next-line no-console
    setAuthNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const [languageUrl, setLanguageUrl] = (0,react.useState)("");
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const { datalayerPageName , featureFlags ={} , globalConfig: { internationalization: { language ="en" , locale =constants.LOCALE_ENGLISH  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    const isMobile =  true && window.innerWidth <= 1200;
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
    const { favorites , saveToListLineItems  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const [authNavShow, setAuthNavShow] = (0,react.useState)(false);
    const [authNavActive, setAuthNavActive] = (0,react.useState)(false);
    const [favoritesPage, setFavoritesPage] = (0,react.useState)([]);
    const [countryNavShow, setCountryNavShow] = (0,react.useState)(false);
    const [countryNavActive, setCountryNavActive] = (0,react.useState)(false);
    const [findAStoreMob, setFindAStoreMob] = (0,react.useState)([]);
    const [languageSwitcherUrl, setLanguageSwitcherUrl] = (0,react.useState)(false);
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [myListsPagePath, setMyListsPagePath] = (0,react.useState)("/");
    eventHandler.callbacks.toggleFindAStore = ()=>{
        dispatch((0,locationSlice.setFindAStoreActive)(false));
    };
    (0,react.useEffect)(()=>{
        if (findAStoreShow) {
            dispatch((0,locationSlice.setFindAStoreActive)(true));
        }
        if (authNavShow) {
            setAuthNavActive(true);
        }
        if (countryNavShow) {
            setCountryNavActive(true);
        }
    }, [
        findAStoreShow,
        authNavShow,
        countryNavShow
    ]);
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) {
            setFavoritesPagePath("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN));
        } else {
            (0,constants_config/* getConfig */.i)().then(async (config)=>{
                const myFavPath = get_default()(config, "general.myFavoritesPagePath", "");
                setFavoritesPagePath(await (0,helper.getShortenedUrl)(myFavPath !== null && myFavPath !== void 0 ? myFavPath : "/"));
            });
        }
        const shortenUrl = async ()=>{
            if (data === null || data === void 0 ? void 0 : data.enableLanguageSwitcher) {
                const shortendUrl = await (0,helper.getShortenedUrl)(data === null || data === void 0 ? void 0 : data.languageUrl);
                setLanguageUrl(shortendUrl);
            }
        };
        shortenUrl();
    }, [
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        const shortenUrlLang = async ()=>{
            var ref, ref1;
            if ((ref = findAStoreMob[4]) === null || ref === void 0 ? void 0 : (ref1 = ref.utilitynavheader) === null || ref1 === void 0 ? void 0 : ref1.enableLanguageSwitcher) {
                var ref2, ref3;
                const shortenUrlLang = await (0,helper.getShortenedUrl)((ref2 = findAStoreMob[4]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.utilitynavheader) === null || ref3 === void 0 ? void 0 : ref3.languageUrl);
                setLanguageUrl(shortenUrlLang);
            }
        };
        shortenUrlLang();
    }, [
        languageSwitcherUrl
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((rsp)=>{
                if (rsp && rsp !== null) {
                    setFavoritesPage(rsp.lineItems);
                } else {
                    setFavoritesPage([]);
                }
            });
            if (isSaveProductToList) {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)()).unwrap().then((res)=>{
                    if (Object.keys(res[1]).length) {
                        setFavoritesPage(Object.keys(res[1]));
                    } else {
                        setFavoritesPage([]);
                    }
                });
            }
        }
    }, [
        isAuth,
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.length) > 0) {
            setFavoritesPage(favorites === null || favorites === void 0 ? void 0 : favorites.lineItems);
        } else {
            setFavoritesPage([]);
        }
    }, [
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (!findAStoreActive) {
            setTimeout(()=>{
                dispatch((0,locationSlice.setFindAStoreShow)(false));
            }, 1000);
        }
        if (!authNavActive) {
            setTimeout(()=>{
                setAuthNavShow(false);
            }, 1000);
        }
        if (!countryNavActive) {
            if (winWidth <= 1200) {
                setCountryNavShow(false);
            } else {
                setTimeout(()=>{
                    setCountryNavShow(false);
                }, 1000);
            }
        }
    }, [
        findAStoreActive,
        authNavActive,
        countryNavActive
    ]);
    (0,react.useEffect)(()=>{
        if (Object.keys(saveToListLineItems).length && isAuth) {
            setFavoritesPage(Object.keys(saveToListLineItems));
        } else {
            setFavoritesPage([]);
        }
    }, [
        Object.keys(saveToListLineItems).length
    ]);
    const toggleFindAStore = ()=>{
        var ref, ref1;
        (0,analytics/* dataLayerForUtilityClicks */.ue)(((ref = data[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : ref1.findStore) || "Find a Store", themeChange);
        if (!findAStoreShow) {
            dispatch((0,locationSlice.setFindAStoreShow)(true));
            (0,helper.toggeleBodyScroll)(true);
        } else {
            if (findAStoreActive) {
                dispatch((0,locationSlice.setFindAStoreActive)(false));
                (0,helper.toggeleBodyScroll)(false);
            } else {
                dispatch((0,locationSlice.setFindAStoreShow)(false));
                (0,helper.toggeleBodyScroll)(false);
            }
        }
    };
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    const iconFavorite = "/icons/favorites-icon.svg";
    const iconFavoriteBlack = "/icons/favorites-full-black.svg";
    const iconLocation = "/icons/location-icon.svg";
    const staticTexts = i18n_useAuthUtilityNavi18n();
    const toggleAuthNav = ()=>{
        setAuthNavShow(!authNavActive);
        (0,helper.toggeleBodyScroll)(!authNavActive);
        setAuthNavActive(!authNavActive);
    };
    const toggleCountryNav = ()=>{
        if (!countryNavActive) {
            setCountryNavShow(true);
            (0,helper.toggeleBodyScroll)(true);
        } else {
            setCountryNavActive(false);
            (0,helper.toggeleBodyScroll)(false);
        }
    };
    const clickEvent = (e)=>{
        if (!(0,helper.isElementExcluded)(e, [
            "header-container",
            "modal-popup",
            "auth-modal"
        ])) {
            !isMobile && !setAuthNavActive(false);
            !isMobile && dispatch((0,locationSlice.setFindAStoreActive)(false));
            !isMobile && setCountryNavActive(false);
            (0,helper.toggeleBodyScroll)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (findAStoreActive) {
            setAuthNavActive(false);
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        findAStoreActive
    ]);
    (0,react.useEffect)(()=>{
        if (authNavActive) {
            dispatch((0,locationSlice.setFindAStoreActive)(false));
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        authNavActive
    ]);
    (0,react.useEffect)(()=>{
        if (countryNavActive) {
            setAuthNavActive(false);
            dispatch((0,locationSlice.setFindAStoreActive)(false));
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        countryNavActive
    ]);
    const style = {
        display: "list-item"
    };
    const displayNone = {
        display: "none"
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = function(e) {
        let path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (!isAuth) {
            window.loginFavouriteCallback = ()=>{
                setLoginFavouriteCallback(e);
            };
            if (path) setMyListsPagePath(path);
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
            e.stopPropagation();
            e.preventDefault();
        }
        (0,analytics/* dataLayerForUtilityClicks */.ue)(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.favorites, themeChange, favoritesPagePath);
        if (path && isAuth) {
            toggleMenu();
        }
    };
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            window.loginFavouriteCallback = null;
            setLoginFavouriteCallback(null);
            window.location.href = myListsPagePath;
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    const onAuthMenuClick = (payload)=>{
        setAuthNavActive(payload);
        setAuthNav(payload);
    };
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    const getNavMobileData = async ()=>{
        const result = await (0,constants_api.aemAxiosInstance)({
            url: "".concat(constants.GLOBAL_CONFIGURATION_ENDPOINT, "?path=").concat(globalConfig.contentFragmentListConfig.map.mobileNavigationFooterLinks),
            method: "GET"
        });
        const commonTopics = JSON.parse(result.data.commonTopics);
        setFindAStoreMob(commonTopics);
    };
    const { contentFragmentListConfig: { map: fragmentList = {}  } = {}  } = globalConfig;
    (0,react.useEffect)(()=>{
        if (Object.keys(fragmentList).length) getNavMobileData();
    }, [
        fragmentList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Shared_index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            isMobile && findAStoreMob.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "gbh-nav__signin",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                            style: style
                                        } : {},
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "list",
                                                className: "utility-widgets utility-widgets__brand-switcher",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AuthUtilityNav, {
                                                    show: authNavShow,
                                                    active: authNavActive,
                                                    toggleAuthNav: toggleAuthNav,
                                                    setAuthNav: setAuthNav,
                                                    onAuthMenuClick: onAuthMenuClick
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "gbh-nav__findStore position_unset",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen && !isAuthNavOpen ? {
                                            style: style
                                        } : {},
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                role: "button",
                                                tabIndex: "0",
                                                "aria-live": "polite",
                                                "aria-labelledby": "find-ada",
                                                className: "gbh-data-layer gbh-nav__findStore--link cmp-find-place",
                                                onClick: ()=>toggleFindAStore(),
                                                children: [
                                                    themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: iconLocation,
                                                        alt: ""
                                                    }) : null,
                                                    ((ref = findAStoreMob[2]) === null || ref === void 0 ? void 0 : ref.label) || "Find a Store"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindStoreUtilNav, {
                                                show: findAStoreShow,
                                                active: findAStoreActive,
                                                eventHandler: eventHandler,
                                                zipCodeContent: zipCodeContent
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        role: "listitem",
                                        className: "wishlist-widget mobile_block position_unset",
                                        ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                            style: style
                                        } : {},
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                            href: favoritesPagePath,
                                            "aria-label": "View your wishlist",
                                            className: "gbh-data-layer",
                                            onClick: (e)=>{
                                                onClickSignIn(e, favoritesPagePath);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "View your wishlist",
                                                    "aria-hidden": "true",
                                                    role: "presentation",
                                                    src: getSrc(themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)
                                                }),
                                                themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (ref1 = findAStoreMob[3]) === null || ref1 === void 0 ? void 0 : ref1.label
                                                }) : null
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        id: "country-ada",
                                        style: displayNone,
                                        children: [
                                            "Country Selector",
                                            " ",
                                            "United States" || (0),
                                            " -",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "gbh-nav__region region_arrowdropdown",
                                        id: "United States".toLowerCase().split(" ").join("_") || (data === null || data === void 0 ? void 0 : data.country.toLowerCase().split(" ").join("_")),
                                        ...isOpen && !mainCategoryActive ? {
                                            style: style
                                        } : {},
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                role: "button",
                                                tabIndex: "0",
                                                "aria-labelledby": "country-ada",
                                                "aria-expanded": countryNavActive,
                                                onClick: ()=>{
                                                    setRegionNav(true);
                                                    toggleCountryNav();
                                                },
                                                className: "gbh-data-layer gbh-nav__region--link active-country ".concat(data.enableLanguageSwitcher ? "selected-country" : "", " ").concat(countryNavActive ? "expand" : ""),
                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName, ':global header","internalLinkURL":"n/a","internalLinkName":"').concat((ref2 = "United States" || (0)) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), " - ").concat((ref3 = (data === null || data === void 0 ? void 0 : data.language) || "EN") === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","eventName":"country select","internalLinkType":"global header : navigation","eventType":"click","eventAction":"country select"}'),
                                                children: [
                                                    "United States" || (0),
                                                    " -",
                                                    " ",
                                                    ((ref4 = findAStoreMob[4]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.utilitynavheader) === null || ref5 === void 0 ? void 0 : ref5.language) || "EN"
                                                ]
                                            }),
                                            ((ref6 = findAStoreMob[4]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.utilitynavheader) === null || ref7 === void 0 ? void 0 : ref7.enableLanguageSwitcher) && locale !== constants.LOCALE_ENGLISH ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                role: "button",
                                                href: languageUrl,
                                                rel: "noreferrer",
                                                "aria-label": (ref8 = findAStoreMob[4]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.utilitynavheader) === null || ref9 === void 0 ? void 0 : ref9.languageLabel,
                                                className: "country-selector",
                                                onClick: ()=>{
                                                    setLanguageSwitcherUrl(true);
                                                },
                                                children: (ref10 = findAStoreMob[4]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.utilitynavheader) === null || ref11 === void 0 ? void 0 : ref11.languageLabel
                                            }) : null,
                                            ((ref13 = findAStoreMob === null || findAStoreMob === void 0 ? void 0 : (ref12 = findAStoreMob[4]) === null || ref12 === void 0 ? void 0 : ref12.utilitynavheader[":items"]) === null || ref13 === void 0 ? void 0 : ref13.countryselector) && countryNavShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNav, {
                                                show: true,
                                                countryselector: (ref15 = (ref14 = findAStoreMob[4]) === null || ref14 === void 0 ? void 0 : ref14.utilitynavheader[":items"]) === null || ref15 === void 0 ? void 0 : ref15.countryselector,
                                                active: countryNavActive,
                                                eventHandler: eventHandler,
                                                toggleCountryNav: toggleCountryNav,
                                                datalayerPageName: datalayerPageName
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "gbh-nav__findStore mobile_none",
                                ...isOpen && !mainCategoryActive && !isRegionOpen && !isAuthNavOpen ? {
                                    style: style
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        tabIndex: "0",
                                        "aria-live": "polite",
                                        "aria-labelledby": "find-ada",
                                        className: "gbh-data-layer gbh-nav__findStore--link cmp-find-place",
                                        onClick: ()=>toggleFindAStore(),
                                        children: [
                                            themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: iconLocation,
                                                alt: ""
                                            }) : null,
                                            ((ref16 = data[":items"]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.store) === null || ref17 === void 0 ? void 0 : ref17.findStore) || "Find a Store"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindStoreUtilNav, {
                                        show: findAStoreShow,
                                        active: findAStoreActive,
                                        eventHandler: eventHandler,
                                        zipCodeContent: zipCodeContent
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "country-ada",
                                style: displayNone,
                                children: [
                                    "Country Selector",
                                    " ",
                                    "United States" || (0),
                                    " -",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "gbh-nav__region region_arrowdropdown mobile_none",
                                id: "United States".toLowerCase().split(" ").join("_") || (data === null || data === void 0 ? void 0 : data.country.toLowerCase().split(" ").join("_")),
                                ...isOpen && !mainCategoryActive ? {
                                    style: style
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        tabIndex: "0",
                                        "aria-labelledby": "country-ada",
                                        "aria-expanded": countryNavActive,
                                        onClick: ()=>{
                                            setRegionNav(true);
                                            toggleCountryNav();
                                        },
                                        className: "gbh-data-layer gbh-nav__region--link active-country ".concat(data.enableLanguageSwitcher ? "selected-country" : "", " ").concat(countryNavActive ? "expand" : ""),
                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName, ':global header","internalLinkURL":"n/a","internalLinkName":"').concat((ref18 = "United States" || (0)) === null || ref18 === void 0 ? void 0 : ref18.toLowerCase(), " - ").concat((ref19 = (data === null || data === void 0 ? void 0 : data.language) || "EN") === null || ref19 === void 0 ? void 0 : ref19.toLowerCase(), '","eventName":"country select","internalLinkType":"global header : navigation","eventType":"click","eventAction":"country select"}'),
                                        children: [
                                            "United States" || (0),
                                            " -",
                                            " ",
                                            (data === null || data === void 0 ? void 0 : data.language) || "EN"
                                        ]
                                    }),
                                    data.enableLanguageSwitcher && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        href: languageUrl,
                                        rel: "noreferrer",
                                        "aria-label": data.languageLabel,
                                        className: "country-selector",
                                        children: data.languageLabel
                                    }),
                                    ((ref20 = data[":items"]) === null || ref20 === void 0 ? void 0 : ref20.countryselector) && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNav, {
                                        show: countryNavShow,
                                        countryselector: (ref21 = data[":items"]) === null || ref21 === void 0 ? void 0 : ref21.countryselector,
                                        active: countryNavActive,
                                        eventHandler: eventHandler,
                                        toggleCountryNav: toggleCountryNav,
                                        datalayerPageName: datalayerPageName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin mobile_none",
                                ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                    style: style
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_AuthUtilityNav, {
                                                show: authNavShow,
                                                active: authNavActive,
                                                toggleAuthNav: toggleAuthNav,
                                                setAuthNav: setAuthNav,
                                                onAuthMenuClick: onAuthMenuClick
                                            }),
                                            (winWidth > 1200 || themeChange) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "wishlist-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                            href: favoritesPagePath,
                                                            "aria-label": "View your wishlist",
                                                            className: "gbh-data-layer",
                                                            onClick: onClickSignIn,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    alt: "View your wishlist",
                                                                    "aria-hidden": "true",
                                                                    role: "presentation",
                                                                    src: getSrc(themeChange, favoritesPage, iconFavoriteBlack, iconFavorite)
                                                                }),
                                                                themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: isSaveProductToList ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myLists : staticTexts.favorites
                                                                }) : null
                                                            ]
                                                        })
                                                    }),
                                                    (data === null || data === void 0 ? void 0 : data.linkCart) && !themeChange && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "cart-indicator-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* default */.Z, {
                                                            eventHandler: eventHandler,
                                                            source: "from desk"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_UtilityNavHeader = (UtilityNavHeader);


/***/ }),

/***/ 36130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56387);
/* harmony import */ var _components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49139);




const AutoSuggestion = (param)=>{
    let { id , borderValue , placeholderLabel , prefix , suffix , optionList , ariaLabel , selectedValue , iconAnalyticsdata , handleSelect , handleChange , title =""  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getInputVal = (item)=>{
        const value = item.replace(_constants_regex__WEBPACK_IMPORTED_MODULE_2__/* .ZIP_CODE_MATCH_WHITESPACE_REGEX */ .bY, "").match(_constants_regex__WEBPACK_IMPORTED_MODULE_2__/* .ZIP_CODE_DIGIT_REGEX */ .lY);
        const inputVal = value != null ? value[0] : item;
        handleChange(inputVal);
        setIsOpen(true);
    };
    const getSuggestionVal = (item)=>{
        handleSelect(item);
        setIsOpen(false);
    };
    document.addEventListener("click", function(e) {
        var ref;
        if (setIsOpen && !((ref = document.getElementById("".concat(id, "-wrapper"))) === null || ref === void 0 ? void 0 : ref.contains(e.target))) setIsOpen(false);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_core_AutoSuggestion_v1_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().autoSuggetionWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "auto-suggestion",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "auto-suggestion__input-container ".concat(borderValue === "bottom" ? "auto-suggestion__border-bottom" : "auto-suggestion__border-all"),
                        children: [
                            prefix !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "auto-suggestion__input-field-prefix",
                                children: prefix
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                className: "auto-suggestion__input",
                                placeholder: placeholderLabel,
                                value: selectedValue,
                                onChange: (e)=>getInputVal(e.target.value),
                                "aria-label": ariaLabel,
                                onBlur: ()=>setIsOpen(false),
                                title: title
                            }),
                            suffix !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "auto-suggestion__input-field-suffix " + (iconAnalyticsdata ? "gbh-data-layer" : ""),
                                "data-gbh-data-layer": iconAnalyticsdata || null,
                                children: suffix
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "auto-suggestion__dropdown ".concat(isOpen ? " active" : ""),
                        children: (optionList === null || optionList === void 0 ? void 0 : optionList.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "auto-suggestion__dropdown-items",
                            children: optionList.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onMouseDown: ()=>getSuggestionVal(item),
                                    className: "auto-suggestion__dropdown-item",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "auto-suggestion__dropdown-item-value",
                                        children: item
                                    })
                                }, i))
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoSuggestion);


/***/ }),

/***/ 65764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/Checkbox/index.module.scss
var index_module = __webpack_require__(43090);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./public/icons/checkbox-tick.svg
/* harmony default export */ var checkbox_tick = ({"src":"/_next/static/media/checkbox-tick.3804ed83.svg","height":10,"width":12});
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/core/Checkbox/Checkbox.jsx







const Checkbox = (props)=>{
    const [config, setConfig] = (0,react.useState)({});
    const { textClassName ="checkbox_default" , inline =false  } = props;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config === null || config === void 0 ? void 0 : config.general);
        }).catch((err)=>console.log(err));
    }, []);
    const handleCheck = (e)=>{
        e.target.checked = !props.checked;
        if (e.keyCode === 32 || e.keyCode === 13) {
            props.onChange(e);
            e.preventDefault();
        }
    };
    var _tabIndex, _role, _checkBoxAria, ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).checkboxWrapper).concat(inline ? " ".concat((index_module_default()).inlineCheckbox) : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            tabIndex: (_tabIndex = props.tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
            "aria-checked": props.checked,
            role: (_role = props.role) !== null && _role !== void 0 ? _role : "checkbox",
            "aria-label": (_checkBoxAria = props.checkBoxAria) !== null && _checkBoxAria !== void 0 ? _checkBoxAria : props.aria,
            htmlFor: props.id,
            className: classnames_default()({
                checkbox: true,
                "checkbox--swatch": props.swatch,
                "checkbox--black": props.type === "black"
            }),
            onKeyDown: handleCheck,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    "data-gbh-data-layer": props.analyticsData || null,
                    "data-gbh-data-layer-custom": props.analyticsDataCustom || null,
                    className: props.analyticsData ? "gbh-data-layer" : "",
                    type: "checkbox",
                    name: props.id,
                    id: props.id,
                    onChange: (e)=>props.onChange(e),
                    checked: props.checked,
                    disabled: props.disabled,
                    "data-testid": (ref = props === null || props === void 0 ? void 0 : props.dataTestId) !== null && ref !== void 0 ? ref : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "checkbox__border",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "checkbox__marker",
                        children: (checkbox_tick === null || checkbox_tick === void 0 ? void 0 : checkbox_tick.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "checkbox__marker-icon",
                            src: checkbox_tick.src,
                            alt: "checkbox-icon",
                            "aria-hidden": true
                        }) : null
                    })
                }),
                (config === null || config === void 0 ? void 0 : config.swatchUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "checkbox__swatch",
                    style: {
                        backgroundImage: 'url("'.concat(config === null || config === void 0 ? void 0 : config.swatchUrl).concat(props === null || props === void 0 ? void 0 : props.swatch, '?$PLPSwatch_Mobile50$")')
                    }
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: textClassName,
                    children: props.value
                })
            ]
        })
    });
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
Checkbox.protoTypes = {
    textClassName: (prop_types_default()).string,
    checked: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    tabIndex: (prop_types_default()).number,
    role: (prop_types_default()).string,
    checkBoxAria: (prop_types_default()).string,
    aria: (prop_types_default()).string,
    swatch: (prop_types_default()).string,
    type: (prop_types_default()).string,
    analyticsData: (prop_types_default()).object,
    analyticsDataCustom: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    value: (prop_types_default()).bool,
    onChange: (prop_types_default()).func
};


/***/ }),

/***/ 30394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2595);



/**
 *
 * @return {{width, height}}
 */ const useWindowDimensions = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const [windowDimensions, setWindowDimensions] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        winWidth: 0,
        winHeight: 0
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) {
            return;
        }
        const { innerWidth: width , innerHeight: height  } = window;
        /**
     * Set window dimensions on resize
     */ const handleResize = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(()=>{
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
        }, 300);
        if (!isSsr) {
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
            window.addEventListener("resize", handleResize);
        }
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        isSsr
    ]);
    return windowDimensions;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowDimensions);


/***/ }),

/***/ 50238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authUtilityNavWrapper":"AuthUtilityNav_authUtilityNavWrapper__iJgYU"};

/***/ }),

/***/ 19371:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"countrySelectorMain":"CountryUtilNav_countrySelectorMain__0qrTO","fadeout":"CountryUtilNav_fadeout__5AsJW","fadein":"CountryUtilNav_fadein__g_qQo"};

/***/ }),

/***/ 4201:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findAStoreUtilNavWrapper":"v1_findAStoreUtilNavWrapper__zMdNe","findstore-util-nav__container":"v1_findstore-util-nav__container__jdVZe","findstore-util-nav__link-container":"v1_findstore-util-nav__link-container__3HSN5"};

/***/ }),

/***/ 84181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"utilityWidgetsWrapper":"UtilityWidgets_utilityWidgetsWrapper__Wz0ZS"};

/***/ }),

/***/ 3738:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additionalFooterWrapper":"Shared_additionalFooterWrapper__OtCXx","mainFooterWrapper":"Shared_mainFooterWrapper__gUYOZ","utilityNavHeaderWrapper":"Shared_utilityNavHeaderWrapper__F3u85"};

/***/ }),

/***/ 56387:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"autoSuggetionWrapper":"v1_autoSuggetionWrapper__DHuiH"};

/***/ }),

/***/ 43090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__Fv9jK","inlineCheckbox":"Checkbox_inlineCheckbox__s9vUb"};

/***/ })

}]);